export enum Periods {
  past = -1,
  current = 0
}